import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getFavoriteDoctors} from '../services/getFavoriteDoctors';
import {FavoriteDoctorsResponse} from 'domain/usecases';

export function useGetFavoriteDoctorsQuery() {
	return useQuery<FavoriteDoctorsResponse>({
		queryKey: [QUERY_KEYS.HEALTH_GUIDE_FAVORITE_DOCTORS],
		queryFn: ({signal}) => getFavoriteDoctors({signal}),
	});
}
